var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAccordionMenuOpen)?_c('FloatingAccordionMenu',{staticClass:"accordion-menu",on:{"closeMenu":_vm.onMenuClose}},[_c(_vm.accordionMenuItem.component,_vm._g(_vm._b({tag:"component",class:_vm.accordionMenuItem.class,on:{"action-selected":_vm.onMenuClose}},'component',_vm.accordionMenuItem.props,false),_vm.$listeners))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }